import React, { Component } from 'react';
import { Table, Row, Col, Container, Spinner, Alert } from 'reactstrap';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import InsigniaCard from './InsigniaCard';
import InsigniaResultCard from './InsigniaResultCard';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import SideBar from './SideBar';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

export class InsigniasAdmin extends Component {
    static displayName = InsigniasAdmin.name;

  constructor(props) {
      super(props);
      this.state = {
          iduser: props.iduser,
          insignias: [],
          insigniaResult: [],
          criterio: {},
          loading1: true,
          loading2: true,
          loading3: true,
          ultimoCambio: '0001/01/01T00:00',
      };
  }

    componentDidMount() {
        if (this.state.iduser > 0) {
            this.populateInsigniaData();
            this.getUltimoCambio();
            this.populateCriterio(this.state.iduser);
            this.populateInsigniaResult(this.state.iduser);
        }
    }

    componentDidUpdate() {
        if (this.state.iduser > 0) {
            this.getUltimoCambio();
            this.populateCriterio(this.state.iduser);
            this.populateInsigniaResult(this.state.iduser);
        }
    }

    componentWillReceiveProps(props) {
        this.setState({
            iduser: props.iduser, insignias: [],
            insigniaResult: [],
            criterio: [],
            loading1: true,
            loading2: true,
            loading3: true,
            ultimoCambio: '0001/01/01T00:00',
        });
    }

    renderInsigniasCard(insignias, result, criterio) {
        let className2 = "col-4";
        return (            
            <> 
                <h1>Insignias</h1>
                <div className="row d-flex flex-row">
                    {result.map((resul, i) =>
                        <Col xs={12} md={4} key={i}>
                            <InsigniaResultCard insignia={resul} criterios={criterio} />
                        </Col>
                    )}
                </div>
                {this.state.insigniaResult.length == 0 ?
                    <>
                        <Alert color="warning">
                            <p>
                                En este momento no registra actividades aprobadas, posiblemente se encuentren en revisi&oacute;n. Una vez aprobadas el avance de sus insignias se reflejara en esta secci&oacute;n.
                            </p>
                        </Alert>
                        <div className="row d-flex flex-row">
                            {insignias.map(insignia =>
                                <div className="col-4">
                                    <InsigniaCard insignia={insignia} />
                                </div>
                            )}
                        </div>
                    </>
                    : <></>
                }
            </>                
            )
    }

    render() {

        if (this.state.iduser > 0) {
            let contents = this.state.loading1 || this.state.loading2 ?
                <> <Spinner animation="grow" /></>
                : this.renderInsigniasCard(this.state.insignias, this.state.insigniaResult, this.state.criterio);

            let alertUltimoCambio = this.state.loading3 ?
                <> <Spinner animation="grow" /></>
                : <Alert color="primary">
                    <p>
                        Para las insignias solo cuentan las actividades aprobadas.
                    </p>
                    <p>
                        Ultima Actualizaci&oacute;n: <strong>{this.state.ultimoCambio != null ? this.state.ultimoCambio.split("T")[0] : 'Null'}   {this.state.ultimoCambio != null ? this.state.ultimoCambio.split("T")[1].substring(0, 5) : ''}</strong>.
                    </p>
                </Alert>;

            return (
                <div>
                    {alertUltimoCambio}
                    <div>
                        {contents}
                    </div>
                </div>

            );
        } else {
            return <div> </div>
        }

      
    }

    populateInsigniaData() {
        fetch(localBack + '/api/Insignia', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    insignias: data.objDatos,
                });
            });       

    }

    populateInsigniaResult(id) {
        fetch(localBack + '/api/ResultadoInsignia/GetbyEstudiante/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('insignia: ', data);*/
                this.setState({ insigniaResult: data.objDatos, loading1: false });
            });
        /*console.log('Resultado ', this.state.insigniaResult);*/

    }

    populateCriterio(id) {
        fetch(localBack + '/api/ResultadoCriterio/GetWithCriterioAgrupado/'+id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('criterio: ', data);*/
                this.setState({ criterio: data.objDatos, loading2: false });
            });
    }

    getUltimoCambio() {
        fetch(localBack + '/api/ResultadoInsignia/GetUltimoCambio', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('insignia: ', data);*/
                if (data.objDatos != null)
                    this.setState({ ultimoCambio: data.objDatos.ultimoCambio, loading3: false });

            });

    }

}


export default InsigniasAdmin;
